export default class PdfTemplateBox {
    constructor(box) {
        this.id = box.id;
        this.x1 = box.x1;
        this.y1 = box.y1;
        this.width = box.width;
        this.height = box.height;
        this.template_id = box.template_id;
    }

    static getBoxes(boxes) {
        const templateBoxes = [];
        boxes.forEach(box => {
            templateBoxes.push(new PdfTemplateBox(box));
        });
        return templateBoxes;
    }
}